import { Campaign } from 'layouts';

export default Campaign;
